import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import About from '@/components/About'
import Shop from '@/components/Shop'
import Product from '@/components/shop/Product'
import Stories from '@/components/Stories'
import Faq from '@/components/Faq'
import Contact from '@/components/Contact'
import Cart from '@/components/Cart'
import EditInscription from '@/components/cart/EditInscription'
import Checkout from '@/components/Checkout'
import Payment from '@/components/Payment'
import Confirmation from '@/components/Confirmation'
import NotFound from '@/components/NotFound'

Vue.use(Router)

/* global FRS_CAMPAIGN */
var prefix = ['/', FRS_CAMPAIGN, '/'].join('');

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/shop',
            name: 'Shop',
            component: Shop
        },
        {
            path: '/product/:id',
            name: 'Product',
            component: Product
        },
        {
            path: '/stories',
            name: 'Stories',
            component: Stories
        },
        {
            path: '/faq',
            name: 'FAQ',
            component: Faq
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/cart',
            name: 'Cart',
            component: Cart
        },
        {
            path: '/cart/:id/inscription',
            name: 'EditInscription',
            component: EditInscription
        },
        {
            path: '/checkout',
            name: 'Checkout',
            component: Checkout
        },
        {
            path: '/payment',
            name: 'Payment',
            component: Payment
        },
        {
            path: '/confirmation',
            name: 'Confirmation',
            component: Confirmation
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound
        }
    ],
    base: prefix
    // mode: 'history',
    // scrollBehavior: () => { return { x: 0, y: 0 } }
})



// WEBPACK FOOTER //
// ./src/router/index.js